import React from 'react';
import { Link } from 'react-router-dom';

export default function ContactNote() {
    return <section className="contact-note shell"><div><p className="section-kicker">Have something in mind?</p><h2>I'd like to hear about it.</h2><p>A new product, a difficult feature, or a team that could use another builder.</p></div><Link to="/contact" className="button button--primary">Let's talk <span aria-hidden="true">↗</span></Link></section>;
}
